module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = void 0;
    var _Spinner = __webpack_require__(2), _Spinner2 = _interopRequireDefault(_Spinner);
    exports.default = _Spinner2.default;
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(3), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(4), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(6), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(7), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(8), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(9), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(10), _react2 = _interopRequireDefault(_react), _Container = __webpack_require__(11), _Container2 = _interopRequireDefault(_Container), _Dash = __webpack_require__(14), _Dash2 = _interopRequireDefault(_Dash), _Wrapper = __webpack_require__(16), _Wrapper2 = _interopRequireDefault(_Wrapper), DEFAULT_SPINNER_DELAY = 100, SIZES = [ "small", "medium", "large", "xlarge" ], SIZES_MAP = {
        small: 20,
        medium: 30,
        large: 50,
        xlarge: 100
    }, DEFAULT_SIZE = SIZES_MAP.small, NOOP = function() {}, Spinner = function(_PureComponent) {
        function Spinner() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, Spinner);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Spinner.__proto__ || (0, 
            _getPrototypeOf2.default)(Spinner)).call.apply(_ref, [ this ].concat(args))), _this.state = {
                spinnerDelayTimeout: null,
                spinnerHiddenForDelay: !0
            }, _this.showSpinnerAfterDelay = function() {
                _this.state.spinnerDelayTimeout && clearTimeout(_this.state.spinnerDelayTimeout), 
                _this.setState({
                    spinnerDelayTimeout: setTimeout(_this.handleSpinnerDelayEnd, _this.props.delay),
                    spinnerHiddenForDelay: !0
                });
            }, _this.handleSpinnerDelayEnd = function() {
                _this.setState({
                    spinnerHiddenForDelay: !1
                });
            }, _this.handleTransitionEnd = function(e) {
                // we have to check that props.isCompleting as a transitionEnd event will be fired when starting
                // up and winding down. This could lead to a case where a spinner starts completing and is then
                // sets isCompleting="false" in which case onComplete will not be called, which is expected
                // behaviour (the transition did not complete).
                "stroke-dashoffset" === e.propertyName && _this.props.isCompleting && _this.props.onComplete();
            }, _this.validateSize = function() {
                var size = _this.props.size, spinnerSize = SIZES_MAP[size] || size;
                return "number" != typeof spinnerSize && (spinnerSize = DEFAULT_SIZE), spinnerSize;
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(Spinner, _PureComponent), (0, _createClass3.default)(Spinner, [ {
            key: "componentDidMount",
            value: function() {
                this.props.isCompleting || this.showSpinnerAfterDelay();
            }
        }, {
            key: "componentWillReceiveProps",
            value: function(nextProps) {
                // if we werent displaying the spinner and now we are
                this.props.isCompleting && !nextProps.isCompleting && this.showSpinnerAfterDelay();
            }
        }, {
            key: "componentWillUnmount",
            value: function() {
                this.state.spinnerDelayTimeout && clearTimeout(this.state.spinnerDelayTimeout);
            }
        }, {
            key: "render",
            value: function() {
                var isCompleting = this.props.isCompleting, size = this.validateSize(), strokeWidth = Math.round(size / 10), strokeRadius = size / 2 - strokeWidth / 2, circumference = Math.PI * strokeRadius * 2, dimensions = {
                    height: size,
                    width: size
                }, dashStyles = {
                    // need to set as px, otherwise Edge doesn't trigger the transition end
                    // see https://stackoverflow.com/questions/24918529/animate-path-in-internet-explorer/24918639#24918639
                    strokeDashoffset: (isCompleting ? circumference : .8 * circumference) + "px",
                    strokeDasharray: circumference
                }, spinnerIsActive = !isCompleting && !this.state.spinnerHiddenForDelay;
                return _react2.default.createElement(_Container2.default, {
                    active: spinnerIsActive,
                    hidden: this.state.spinnerHiddenForDelay,
                    onTransitionEnd: this.handleTransitionEnd,
                    style: dimensions
                }, _react2.default.createElement(_Wrapper2.default, null, _react2.default.createElement("svg", (0, 
                _extends3.default)({}, dimensions, {
                    focusable: "false",
                    viewBox: "0 0 " + size + " " + size,
                    xmlns: "http://www.w3.org/2000/svg"
                }), _react2.default.createElement(_Dash2.default, {
                    active: spinnerIsActive,
                    cx: size / 2,
                    cy: size / 2,
                    fill: "none",
                    invertColor: this.props.invertColor,
                    r: strokeRadius,
                    strokeLinecap: "round",
                    strokeWidth: strokeWidth,
                    style: dashStyles
                }))));
            }
        } ]), Spinner;
    }(_react.PureComponent);
    Spinner.propTypes = {
        /** Time in milliseconds after component mount before spinner is visible. */
        delay: _propTypes2.default.number,
        /** Set the spinner color to white, for use in dark-themed UIs. */
        invertColor: _propTypes2.default.bool,
        /** Setting this to true causes the spinner to animate its disappearance.
	  Setting it to false again will cause the spinner to animate back in. */
        isCompleting: _propTypes2.default.bool,
        /** Handler for once the spinner has completed its outro animation */
        onComplete: _propTypes2.default.func,
        /** Size of the spinner. */
        size: _propTypes2.default.oneOfType([ _propTypes2.default.number, _propTypes2.default.oneOf(SIZES) ])
    }, Spinner.defaultProps = {
        delay: DEFAULT_SPINNER_DELAY,
        invertColor: !1,
        isCompleting: !1,
        onComplete: NOOP,
        size: SIZES[0]
    }, exports.default = Spinner;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("prop-types");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 11 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(12), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  from { transform: rotate(230deg); }\n  to { transform: rotate(510deg); }\n" ], [ "\n  from { transform: rotate(230deg); }\n  to { transform: rotate(510deg); }\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  from { transform: rotate(50deg); }\n  to { transform: rotate(230deg); }\n" ], [ "\n  from { transform: rotate(50deg); }\n  to { transform: rotate(230deg); }\n" ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  animation: ", " ease-in-out forwards;\n  display: inline-flex;\n  opacity: ", ";\n" ], [ "\n  animation: ", " ease-in-out forwards;\n  display: inline-flex;\n  opacity: ", ";\n" ]), _styledComponents = __webpack_require__(13), _styledComponents2 = _interopRequireDefault(_styledComponents), spinnerLoad = (0, 
    _styledComponents.keyframes)(_templateObject), spinnerLoadActive = (0, _styledComponents.keyframes)(_templateObject2), getOpacity = function(_ref) {
        var hidden = _ref.hidden;
        return hidden ? 0 : 1;
    }, getAnimation = function(_ref2) {
        var active = _ref2.active;
        return active ? spinnerLoadActive + " 1s" : spinnerLoad + " 0.53s";
    };
    exports.default = _styledComponents2.default.div(_templateObject3, getAnimation, getOpacity);
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 14 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.getStrokeColor = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(12), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  opacity: ", ";\n  stroke: ", ";\n  transform-origin: center;\n  transition: stroke-dashoffset 0.8s ease-in-out, opacity 0.2s ease-in-out;\n  transition-delay: ", ";\n" ], [ "\n  opacity: ", ";\n  stroke: ", ";\n  transform-origin: center;\n  transition: stroke-dashoffset 0.8s ease-in-out, opacity 0.2s ease-in-out;\n  transition-delay: ", ";\n" ]), _styledComponents = __webpack_require__(13), _styledComponents2 = _interopRequireDefault(_styledComponents), _utilSharedStyles = __webpack_require__(15), getOpacity = function(_ref) {
        var active = _ref.active;
        return active ? 1 : 0;
    }, getTransitionDelay = function(_ref2) {
        var active = _ref2.active;
        return active ? "initial" : "0.45s";
    }, getStrokeColor = exports.getStrokeColor = function(_ref3) {
        var invertColor = _ref3.invertColor;
        return invertColor ? _utilSharedStyles.akColorN0 : _utilSharedStyles.akColorN500;
    };
    exports.default = _styledComponents2.default.circle(_templateObject, getOpacity, getStrokeColor, getTransitionDelay);
}, /* 15 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-shared-styles");
}, /* 16 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _taggedTemplateLiteral2 = __webpack_require__(12), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  to { transform: rotate(360deg); }\n" ], [ "\n  to { transform: rotate(360deg); }\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  animation: ", " 0.86s cubic-bezier(0.4, 0.15, 0.6, 0.85) infinite;\n  display: inline-flex;\n" ], [ "\n  animation: ", " 0.86s cubic-bezier(0.4, 0.15, 0.6, 0.85) infinite;\n  display: inline-flex;\n" ]), _styledComponents = __webpack_require__(13), _styledComponents2 = _interopRequireDefault(_styledComponents), spin = (0, 
    _styledComponents.keyframes)(_templateObject);
    exports.default = _styledComponents2.default.div(_templateObject2, spin);
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/spinner/dist/bundle-cjs.js
// module id = 127
// module chunks = 0